// extracted by mini-css-extract-plugin
module.exports = {"Appointment":"AppointmentTime_Appointment__2FV0C","Active":"AppointmentTime_Active__3zjUk"};